/* POZCA: cart shipping display only; Shopify determines actual checkout rates. */
(function () {
  'use strict';
  if (window.__pozcaShippingReady) return;
  window.__pozcaShippingReady = true;
  var timer = null;
  var sequence = 0;
  var fmt = new Intl.NumberFormat('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  function bars() { return document.querySelectorAll('[data-pozca-shipping]'); }
  function update(cents, itemCount) {
    bars().forEach(function (bar) {
      if (bar.getAttribute('data-pozca-shipping-mode') !== 'goal') return;
      var threshold = Number(bar.getAttribute('data-threshold'));
      if (!Number.isFinite(threshold) || threshold <= 0) return;
      var remaining = Math.max(0, threshold - cents);
      var percent = Math.min(100, Math.max(0, Math.floor(cents * 100 / threshold)));
      var message = remaining > 0
        ? '🚚 Ücretsiz kargoya sadece ' + fmt.format(remaining / 100) + ' ₺ kaldı!'
        : '🎉 Tebrikler! Siparişiniz Ücretsiz Kargo kazandınız!';
      if (itemCount === 0) message = '🚚 1.000 ₺ ve üzeri siparişlerde kargo ücretsiz!';
      if (bar.dataset) bar.dataset.complete = String(cents >= threshold && itemCount !== 0);
      var label = bar.querySelector('[data-pozca-shipping-message]');
      var fill = bar.querySelector('[data-pozca-shipping-fill]');
      var track = bar.querySelector('[data-pozca-shipping-track]');
      if (label && label.textContent.trim() !== message) label.textContent = message;
      if (fill && fill.style.width !== percent + '%') fill.style.width = percent + '%';
      if (track) track.setAttribute('aria-valuenow', String(percent));
    });
  }
  function refresh() {
    var active = Array.prototype.some.call(bars(), function (b) {
      return b.getAttribute('data-pozca-shipping-mode') === 'goal';
    });
    if (!active) return;
    var ticket = ++sequence;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { if (!res.ok) throw new Error('Cart API ' + res.status); return res.json(); })
      .then(function (cart) {
        if (ticket !== sequence || !cart || !Number.isFinite(cart.total_price)) return;
        if (cart.currency && cart.currency !== 'TRY') { bars().forEach(function (b) { b.hidden = true; }); return; }
        bars().forEach(function (b) { b.hidden = false; });
        update(Math.max(0, cart.total_price), cart.item_count);
      })
      .catch(function () { /* No cart writes, keep Liquid view. */ });
  }
  function schedule() { if (timer) clearTimeout(timer); timer = setTimeout(function () { timer = null; refresh(); }, 200); }
  function init() {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate)
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('cart:update', schedule);
    window.addEventListener('pageshow', schedule);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
    var observer = new MutationObserver(function (changes) {
      var changed = changes.some(function (change) {
        if (change.target.nodeType === 1 && change.target.closest('[data-pozca-shipping]')) return false;
        return Array.prototype.some.call(change.addedNodes, function (node) {
          return node.nodeType === 1 && (
            node.matches('[data-pozca-shipping],cart-drawer-items,cart-items,.drawer__inner,.cart-item,.cart__items,.cart__footer') ||
            node.querySelector('[data-pozca-shipping],cart-drawer-items,cart-items,.cart-item')
          );
        });
      });
      if (changed) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (event) {
      if (event.target.closest('#cart-icon-bubble, .cart-drawer__overlay')) schedule();
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
}());
